<template>
<div id="info-banner">
  <div class="content">
    <h1> {{ $t('more_info_question') }} </h1>
    <router-link to="contact">
      <button class="btn-green">
        {{ $t('more_info') }}
      </button>
    </router-link>
  </div>
</div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style lang="scss" scope>

#info-banner {
  background-image:  url("/../../../static/img/infobanner.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  .content {
    transition: all .1s ease-in-out;
    height: 40em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    backdrop-filter: brightness(.8);
    h1 {
      font-size: 3.5em;
      font-family: MuseoSans-900;
      text-transform: uppercase;
      color: white;
      text-align: center;
    }
    button {
      font-family: MuseoSans-900;
      text-transform: uppercase;
      font-size: 1.2em;
      padding: 0 4em;
    }
    &:hover {
      backdrop-filter: blur(.1em) brightness(.6);
    }
  }
}

@media screen and (max-width: 600px) {
  #info-banner {
    .content {
      backdrop-filter: brightness(.6);
      h1 {
        font-size: 2rem;
      }
      button {
          font-size: 1rem;
          padding: 0 3em;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductInfoBanner.vue